import "./Checkout.css";

// Écrans de retour depuis Stripe Checkout. Volontairement déclaratifs : l'état
// réel de l'abonnement est écrit par les webhooks, jamais par cette page — un
// client ne peut pas se déclarer payé en visitant une URL.
function PaymentReturn({ status }) {
  const success = status === "success";

  return (
    <div className="checkout">
      <main className="checkout-main">
        <div className="checkout-card checkout-return">
          {success ? (
            <>
              <span className="rc-badge checkout-return-badge">Mandat signé</span>
              <h1>Merci, votre prélèvement est en route.</h1>
              <p className="checkout-return-text">
                Votre mandat SEPA est enregistré. Le premier prélèvement est
                confirmé par votre banque sous 2 à 5 jours ouvrés : votre offre
                sera activée dès réception. Vous recevrez un e-mail de Stripe
                confirmant le mandat.
              </p>
            </>
          ) : (
            <>
              <span className="rc-badge rc-badge-soft checkout-return-badge">
                Paiement annulé
              </span>
              <h1>Aucun prélèvement n'a été mis en place.</h1>
              <p className="checkout-return-text">
                Vous avez quitté le paiement avant de signer le mandat. Rien
                n'a été enregistré et aucune somme ne sera prélevée. Vous
                pouvez reprendre quand vous le souhaitez.
              </p>
            </>
          )}
          <a className="rc-btn rc-btn-primary checkout-pay-btn" href="/">
            Retour à l'accueil
          </a>
        </div>
      </main>
    </div>
  );
}

export default PaymentReturn;
